<div class="ingredients-header">
  <h2 id="RecipesModifyIngredientStatusLbl">{{ 'VARIANTS.STEPS.INGREDIENTS' | translate }}</h2>
  <div class="ingredients-header-buttons">
    <div *ngIf="showAutoBtn" class="toggle-auto">
      <mat-label class="labelBeforeSlide" matTooltip="{{ 'RECIPES_EDIT.AUTO_DESCRIPTION' | translate }}">
        {{ 'RECIPES_EDIT.AUTO' | translate }}
      </mat-label>
      <mat-slide-toggle [(ngModel)]="isApproved" id="RecipesModifyIngredientAutoChkBox" (change)="toggleApproved()"> </mat-slide-toggle>
      <mat-label class="labelBeforeSlide" matTooltip="{{ 'RECIPES_EDIT.APPROVED_DESCRIPTION' | translate }}">
        <span>{{ 'RECIPES_EDIT.APPROVED' | translate }}</span>
      </mat-label>
    </div>
    <button mat-raised-button class="btn btn-primary" id="RecipesModifyIngredientSyntaxAnalysisBtn" (click)="parseIngredients()">
      <span class="fa fa-cogs space-h-s"></span>
      {{ 'RECIPES_EDIT.INGREDIENTS.PARSING' | translate }}
    </button>
  </div>
</div>
<div cdkDropList (cdkDropListDropped)="onDrop($event)" class="drop-zone" [cdkDropListData]="formIngredients?.controls">
  <app-ingredients-block
    *ngFor="let type of usedIngredientTypes; let index = index"
    [formArray]="formIngredients"
    [type]="type"
    [usedIngredientTypes]="usedIngredientTypes"
    [ingredientTypes]="(ingredientTypes$ | async) || []"
    [units]="yieldUnits"
    [domain]="domain"
    [market]="market"
    [lang]="lang"
    [index]="index"
    [marketingFoods]="marketingFoods"
    (addLine)="addLine($event)"
    (selectIngredientType)="selectIngredientType($event)"
    (deleteBlock)="deleteBlock($event)"
    cdkDrag
  >
  </app-ingredients-block>
</div>

<div class="footer">
  <div class="background-gray">
    <button mat-button class="btn btn-transparent" id="RecipesModifyIngredientBlocAddBtn" (click)="newBlock()">
      {{ 'RECIPES_EDIT.INGREDIENTS.NEW_BLOCK' | translate }}
      <i class="fas fa-plus space-l-m space-v-s" aria-hidden="true"></i>
    </button>
  </div>
</div>

<app-base-preparation-block [formArray]="formIngredients" [domain]="domain" [market]="market" [lang]="lang"> </app-base-preparation-block>
